export type TheoryTierKey = "early" | "regular" | "catchup";

export const THEORY_CURRENCY = "SGD" as const;

export const THEORY_TIER_FEES_SGD: Record<TheoryTierKey, number> = {
  early: 360,
  regular: 380,
  catchup: 400,
} as const;

export const THEORY_MONTHLY_SESSIONS = 4 as const;
export const THEORY_SESSION_DURATION_ISO = "PT1H30M" as const;
